import React from "react";
import { connect } from "react-redux";

import { getSchoolByID } from "state/teachers/selectors";

class SchoolName extends React.Component {
  
  render() {
    return this.props.school.get("name");
  }
  
}

export default connect(
  (state, { schoolID }) => ({
    school: getSchoolByID(state, schoolID)
  })
)(SchoolName);



// WEBPACK FOOTER //
// ./src/components/teachers/SchoolName.js